export default "__VITE_ASSET__CtVaOzpN__"